<div class="p-5">
  <div class="flex justify-between items-center mb-4">
    <div class="text-lg text-gray-700 font-bold">Mensagem ao motorista</div>
    <button class="btn-icon" (click)="close()"><mat-icon>close</mat-icon></button>
  </div>

  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else if (mensagem) {
    @if (mensagem.semMotorista) {
      <div class="mt-3 p-2 rounded bg-yellow-50 text-yellow-800 text-sm">
        Esta OS ainda não tem motorista alocado.
      </div>
    } @else {
      <div class="text-sm text-gray-600 mb-2">
        <b>{{ mensagem.motoristaNome }}</b>
        @if (mensagem.motoristaTelefone) { · {{ mensagem.motoristaTelefone }} }
      </div>
      <textarea class="mensagem-preview" readonly rows="10">{{ mensagem.mensagem }}</textarea>
      <div class="flex justify-end gap-2 mt-4">
        <button mat-flat-button class="btn-tg-white" (click)="copiar()">
          <mat-icon class="mr-1">content_copy</mat-icon> Copiar
        </button>
        <button mat-flat-button class="btn-tg" [disabled]="!mensagem.linkWhatsApp"
          [matTooltip]="!mensagem.linkWhatsApp ? 'Motorista sem telefone cadastrado' : ''" (click)="abrirWhatsApp()">
          <mat-icon class="mr-1">chat</mat-icon> Abrir WhatsApp
        </button>
      </div>
    }
  }
</div>
